import { css } from '@emotion/css';
import styled from '@emotion/styled';
import { Alert, Button, Form, Modal } from 'antd';

export const mb16 = css`
  margin-bottom: 16px;
`;

export const Dialog = styled(Modal)`
  .ant-modal-body {
    position: relative;
    max-height: 80vh;
    padding: 60px 70px;
    overflow: auto;
  }
`;

export const TitleWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;
export const TitleText = styled.div`
  flex: 1;

  &.center {
    text-align: center;
  }
  &.left {
    text-align: left;
  }
`;
export const TitleBackButton = styled(Button)`
  position: absolute;
  left: 0;
  padding: 0;
  color: var(--fett-text-tertiary);

  &:hover {
    background: none;
  }
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const BottomButton = styled(Button)`
  min-width: 180px;
`;
export const bottomButton = css`
  min-width: 180px;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Text = styled.p`
  font-size: 16px;
  margin-top: 26px;
  margin-bottom: 24px;
  text-align: center;
`;

export const Description = styled.div`
  font-size: 14px;
  color: var(--fett-text-tertiary);
  text-align: center;
`;

export const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 86px;
  padding-bottom: 170px;

  & > .anticon {
    font-size: 64px;
  }
`;

export const AuthWayBox = styled.div``;
export const AuthWayTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;

  &.highlight {
    color: var(--ant-primary-color);
  }
`;
export const AuthWayDesc = styled.div`
  font-size: 14px;
  color: var(--fett-text-tertiary);
`;

export const OptButton = styled(Button)`
  min-width: 180px;
`;

export const AbsoluteAuthShopHelper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
`;

export const LittleTips = styled(Alert)`
  padding: 4px 10px;
  margin-bottom: 16px;
`;

export const FormContainer = styled(Form)`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 330px;
  padding-bottom: 40px;

  .ant-form-item-label {
    font-weight: 500;
  }
`;

export const BottomFooter = styled(Footer)`
  flex-direction: column;
  align-items: center;
  position: absolute;
  bottom: 0;
`;
